import React, {useEffect, useState} from 'react';
import {
    Card, CardBody, CardTitle,
} from 'reactstrap';

import {showLoader} from "../../../components/loader/loader";
import {
    clearState,
    setApp,
    setCategory,
    setLoading,
    setUdn,
    setViewMode
} from "../../../redux/actions/generalActions/mainActions";
import { connect } from "react-redux";
import { setForm } from "../../../redux/actions/generalActions/formActions";
import {ButtonCollapseEye, GenericTableButton} from "../../../components/buttons/buttonsActions";
import { confirmAlert } from "react-confirm-alert";
import { TraceForm } from "./_form";
import Map3D from "../../../components/map3d/Map3D";
import {traceService} from "../../../jwt/_services/xeeker/traceService";
import {mapFunctions} from "../../../components/map/mapFunctions";
import {TT_ADD} from "../../../components/i18n/toolTips";

// center: { lat: 20.581465, lng: -87.120603 }

const Trace = (props) => {
    const { loading, udn, app } = props.mainProps
    // const [udn, setUdn] = useState( null);
    // const [app, setApp] = useState( null);

    const [googleConfig, setGoogleConfig] = useState( null );
    const [showTraces, setShowTraces] = useState( true );
    const [show3D, setShow3D] = useState( true );

    const [traces, setTraces] = useState( [] );

    useEffect(() => {
        if (props.app !== null) {
            props.setApp(props.app);
            // setApp(props.app)
        }

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn) {
            if (showTraces)
                loadTraces(_udn, props.app);

            loadGoogleConfig( _udn );
            props.setUdn(_udn);
        }
    },[]);

    const loadTraces = ( _udn, _app ) => {
        if (_udn?.id === undefined || _app?.fbDataBase?.id === undefined)
            return

        const dataRequest = {
            fbDataBase : {  id : _app?.fbDataBase?.id },
            item: {
                udn : { id : _udn.id }
            }
        }

        setLoading(true);
        traceService.search(0, 10000, dataRequest)
            .then(result => {
                if (result){
                    setTraces(result.data);
                }
                setLoading(false);
            })
            .catch(ex => {
                console.log(ex);
                setLoading(false);
            });
    }

    const loadGoogleConfig = ( _udn ) => {

        let _googleConfig = {}

        if (_udn?.id !== undefined){
            mapFunctions.loadMapConfig(_udn)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        _googleConfig =  {
                            mapOptions: {
                                // center: { lat: 20.581465, lng: -87.120603 },
                                center: {
                                    lat: parseFloat(config?.latitude),
                                    lng: parseFloat(config?.longitude)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom + 1,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom + 10
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            }
                        }

                        setGoogleConfig(_googleConfig);
                    }

                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }

    const addTrace = ( _trace ) => {
        setTraces([
            ...traces,
            _trace
        ])
    }

    const onTraceClick = ( _trace ) => {
        let _googleConfig ={
            ...googleConfig
        }

        let startTraceNull = true;

        if ( _trace?.points ) {
            startTraceNull = false;
            const mid = mapFunctions.getMidElement(mapFunctions.mapPointsToMarkers( _trace?.points ));

            _googleConfig = {
                ...googleConfig,
                mapOptions : {
                    ...googleConfig.mapOptions,
                    center: {
                        lat: mid?.position?.lat,
                        lng: mid?.position?.lng
                    }
                }
            }
        }

        return (
            confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) =>
                <>
                    <TraceForm
                        udn={udn}
                        fbDataBaseId={app?.fbDataBase?.id}
                        trace={ !startTraceNull ? _trace : null}
                        onClose={onClose}
                        googleMapConfig={ _googleConfig }
                        addTrace={addTrace}
                        setLoading={props.setLoading}
                    />
                </>
        }));
    };

    const showHideRoutes = ( _marker ) => {
        if (showTraces) {
            loadTraces(udn, app);
        }

        setShowTraces(!showTraces);
    }

    const onDepuratePoints = (  ) => {
        if (udn?.id === undefined || app?.fbDataBase?.id === undefined)
            return

        const dataRequest = {
            fbDataBase : {  id : app?.fbDataBase?.id },
            item: {
                udn : { id : udn.id }
            }
        }

        setLoading(true);
        traceService.depurate( dataRequest)
            .then(_ => {
                setLoading(false);
            })
            .catch(ex => {
                console.log(ex);
                setLoading(false);
            });

    }

    // <FontAwesomeIcon icon="fa-solid fa-droplet-slash" />
    // <FontAwesomeIcon icon="fa-solid fa-code-pull-request" />
    // <FontAwesomeIcon icon="fa-solid fa-code-merge" />
    // <FontAwesomeIcon icon="fa-solid fa-circle-nodes" />
    // <FontAwesomeIcon icon="fa-solid fa-code-fork" />
    // <FontAwesomeIcon icon="fa-solid fa-code-commit" />
    // <FontAwesomeIcon icon="fa-solid fa-arrows-turn-to-dots" />
    // <FontAwesomeIcon icon="fa-solid fa-arrows-split-up-and-left" />
    return (<>
        {loading && showLoader()}
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-list-alt mr-2"> </i>
                <div className="float-right">
                    <GenericTableButton toolTip={'Depurar puntos'} icon={'fa-droplet-slash fa-rotate-180'} permission={'delete'} onClick={onDepuratePoints} disabled={false}/>
                    <ButtonCollapseEye toolTip={'Mostrar objetos 3D'} onClick={_ => setShow3D(!show3D)} status={show3D}/>
                    <ButtonCollapseEye toolTip={'Mostrar trazos'} onClick={showHideRoutes} status={showTraces}/>
                    <GenericTableButton toolTip={'Agregar trazo'} icon={'fa-plus'} permission={'edit'} onClick={onTraceClick} disabled={false}/>
                </div>
            </CardTitle>
            <CardBody>
                <Map3D
                    className="trace-map-container"
                    routes={[...traces]}
                    googleConfig={ googleConfig }
                    options={ {showRouteMarkers: showTraces, showRoutes: showTraces, showEasyPath: false, show3D : show3D, udn : udn} }
                    onTraceClick={onTraceClick}
                />
            </CardBody>
        </Card>
    </>);
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
    setApp,
    setCategory,
    setForm,
    setViewMode,
    setLoading,
});

export default connect(mapStateToProps, mapActionsToProps)(Trace)
